module.exports = __webpack_public_path__ + "static/media/bulb_3.68ce22df.png";